import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';
import { getTicketMessagesById } from './getTicketMessagesById';

export const agentReplyToTicket = createAsyncThunk(
  'ticket/agentReplyToTicket',
  async ({ ticketId, message, attachments,isPrivate }, { getState, dispatch, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      const formData = new FormData();
      
      formData.append('ticketId', ticketId);
      formData.append('message', message);
      formData.append('business_id', business_id);
      formData.append('isPrivate', isPrivate);
      
      if (attachments && attachments.length > 0) {
        attachments.forEach((file, index) => {
          formData.append(`attachments`, file);
        });
      }

      const response = await axios.post(
        `${ROOT_URL}/ticket/email-reply`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            // Don't set Content-Type when sending FormData - axios will set it automatically with boundary
          },
        }
      );

      // await dispatch(getTicketMessagesById(ticketId));
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false
};

const agentReplyToTicketSlice = createSlice({
  name: 'agentReplyToTicket',
  initialState,
  reducers: {
    resetReplyState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(agentReplyToTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(agentReplyToTicket.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(agentReplyToTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetReplyState } = agentReplyToTicketSlice.actions;
export default agentReplyToTicketSlice.reducer; 